// extracted by mini-css-extract-plugin
export var embla = "EmblaCarousel-module--embla--Ngm2t";
export var emblaContainer = "EmblaCarousel-module--emblaContainer--OiWYW";
export var emblaControls = "EmblaCarousel-module--emblaControls--WY7oH";
export var emblaDot = "EmblaCarousel-module--emblaDot--l2uRy";
export var emblaDotSelected = "EmblaCarousel-module--emblaDotSelected--hqSyN";
export var emblaDots = "EmblaCarousel-module--emblaDots--vhWZP";
export var emblaNext = "EmblaCarousel-module--emblaNext--rXnRt";
export var emblaPrev = "EmblaCarousel-module--emblaPrev--HtR89";
export var emblaSlide = "EmblaCarousel-module--emblaSlide--IyDQs";